import React from 'react';
import './App.css';
import MarioGame from './components/MarioGame';
import ErrorBoundary from './components/ErrorBoundary';

export default function App() {
  return <ErrorBoundary><div className="App"><MarioGame /></div></ErrorBoundary>;
}
